'use strict';

module.exports = function (date) {
  var padded = date.toString();
  if (padded.length === 1) {
    padded = '0' + date.toString();
  }
  return padded;
};